import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Flex,
  Grid,
  Row,
  Skeleton,
  Space,
  Tag,
  Typography,
  theme,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import brokenImg from "../../../assets/v2/broken-icon.png";
import accountTypes from "../../../constants/accountTypes";
import {
  ACTIONTYPES,
  useStore,
  useStoreDispatch,
} from "../../../context/CreateStoreContext";
import style from "./StoreList.module.css";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const { useToken } = theme;

export default function StoreList({ storeList, loading, hasError }) {
  const { token } = useToken();
  const screen = useBreakpoint();
  const [allowAddStore, setAllowAddStore] = useState(false);
  const { selectedStore: selected = {}, parentStore } = useStore();
  const dispatch = useStoreDispatch();
  const activeStatus = ["active", "trialing", "cancelling"];
  const navigate = useNavigate();
  const isIntegrator = parentStore?.integratorId || false;
  const isSubscribe = (status) => activeStatus.includes(status);
  // const menuButtonRef = useRef(null);
  // const [menuButtonProperties, setmenuButtonProperties] = useState(null);
  const [openList, setOpenList] = useState(false);

  const subsLabel = (status) => {
    const _isSubscribe = isSubscribe(status);
    const isScreenMd = screen.md === true && screen.lg === false;

    if (_isSubscribe && isScreenMd) {
      return "Sub";
    } else if (!_isSubscribe && isScreenMd) {
      return "Unsub";
    }

    if (_isSubscribe) {
      return "Subscribed";
    } else {
      return "Unsubscribed";
    }
  };

  const handleAddNewStore = () => {
    dispatch({ type: ACTIONTYPES.CLEAR_FORM_STATES });
    dispatch({ type: ACTIONTYPES.ACCOUNTTYPE, data: accountTypes.store });
    setTimeout(() => {
      navigate("/create");
    }, 500);
  };

  useEffect(() => {
    const currentStatus = parentStore?.stripeSubscription?.subscriptionStatus;
    let allow = false;

    if (isSubscribe(currentStatus) || currentStatus === "canceled") {
      allow = true;
    } else {
      allow = false;
    }

    setAllowAddStore(allow);
  }, [parentStore?.stripeSubscription?.subscriptionStatus]);

  const handleItemClick = (store, hideList) => {
    if (hideList) {
      setOpenList(false);
    }
    dispatch({
      type: ACTIONTYPES.ADMIN_SELECTEDSTORE,
      data: store,
    });
  };

  // useEffect(() => {
  //   if (menuButtonRef.current) {
  //     const props = menuButtonRef.current.getBoundingClientRect();
  //     console.log(props);
  //     setmenuButtonProperties(props);
  //   }
  // }, []);

  useEffect(() => {
    screen.xs === false && setOpenList(false);
  }, [screen]);

  return screen.xs ? (
    <Flex vertical className={style.StoreList}>
      <Title
        level={3}
        style={{ margin: "0 0 10px 0", textAlign: "center", color: "white" }}
      >
        My Stores
      </Title>

      <Skeleton active loading={loading}>
        {hasError ? null : (
          <>
            <Text style={{ color: "rgb(255 255 255 / 65%)", fontSize: "12px" }}>
              Tap to select stores
            </Text>
            <Flex
              align="center"
              justify="space-between"
              onClick={() => setOpenList((prev) => !prev)}
              style={{
                background:
                  "linear-gradient(90deg, #007AFF 0%, rgba(0, 122, 255, 0.75) 100%)",
                borderRadius: "8px",
                padding: "12px 15px",
                color: "white",
                marginBottom: "11px",
              }}
            >
              <Space direction="vertical" size={0}>
                <Text
                  style={{
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {selected?.storeName}
                </Text>
                <Text
                  style={{
                    color: "white",
                    fontSize: "10px",
                    padding: "4px 10px",
                    backgroundColor: "#0003",
                    borderRadius: "50px",
                  }}
                >
                  {isSubscribe(selected?.stripeSubscription?.subscriptionStatus)
                    ? "Subscribed"
                    : "Unsubscribed"}
                </Text>
              </Space>
              <DownOutlined />
            </Flex>
          </>
        )}

        <Flex justify="center">
          <Button
            type="ghost"
            size="default"
            style={{ color: allowAddStore ? "white" : "grey" }}
            icon={<PlusOutlined />}
            disabled={!allowAddStore}
            onClick={handleAddNewStore}
          >
            Add New Store
          </Button>
        </Flex>
      </Skeleton>

      {openList && (
        <div
          style={{
            position: "absolute",
            top: "160px",
            left: "0",
            color: "white",
            width: "90vw",
            padding: "20px",
            zIndex: 100,
          }}
        >
          <div
            style={{
              position: "relative",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: token.boxShadowSecondary,
              overflowY: "auto",
              maxHeight: "500px",
            }}
          >
            {storeList.map((item) => (
              <Row
                key={item.storeId}
                className={`${style.ListItems} ${
                  selected?.storeId === item.storeId ? style.active : null
                }`}
                onClick={handleItemClick.bind(this, item, true)}
              >
                <Col span={12}>
                  <div style={{ fontSize: "16px", fontWeight: "500" }}>
                    {item.storeName}
                  </div>
                </Col>
                <Col span={12} style={{ textAlign: "end" }}>
                  <div className={style.ItemBadge}>
                    {isSubscribe(item?.stripeSubscription?.subscriptionStatus)
                      ? "Subscribed"
                      : "Unsubs"}
                  </div>
                </Col>
              </Row>
            ))}
          </div>
        </div>
      )}
    </Flex>
  ) : (
    <Flex vertical className={style.StoreList}>
      <div className={style.HeadingContainer}>
        <Flex align="center" justify="space-between">
          <Title level={3} style={{ margin: 0, color: "white" }}>
            My Stores
          </Title>
          <Tag color="#fff3" style={{ borderRadius: "16px", margin: 0 }}>
            {storeList.length}
          </Tag>
        </Flex>
      </div>
      <div className={style.ItemListContainer}>
        {hasError ? (
          <StoreListFailed />
        ) : (
          <Skeleton active loading={loading}>
            {storeList.map((item) => (
              <Row
                key={item.storeId}
                className={`${style.ListItems} ${
                  selected?.storeId === item.storeId ? style.active : null
                }`}
                onClick={handleItemClick.bind(this, item)}
              >
                <Col span={12}>
                  <Text
                    style={{
                      fontSize: screen.md ? "14px" : "16px",
                      fontWeight: "500",
                      color: "white",
                    }}
                    ellipsis
                  >
                    {item.storeName}
                  </Text>
                </Col>
                <Col span={12} style={{ textAlign: "end" }}>
                  <div className={style.ItemBadge}>
                    {subsLabel(item?.stripeSubscription?.subscriptionStatus)}
                  </div>
                </Col>
              </Row>
            ))}
          </Skeleton>
        )}
      </div>
      {isIntegrator ? null : (
        <div className={style.ButtonContainer}>
          <Button
            size="large"
            icon={<PlusOutlined />}
            className={style.btnAddNewStore}
            disabled={!allowAddStore}
            onClick={handleAddNewStore}
          >
            Add New Store
          </Button>
        </div>
      )}
    </Flex>
  );
}

const StoreListFailed = () => (
  <Flex
    vertical
    align="center"
    flex={1}
    justify="center"
    style={{ width: "100%" }}
  >
    <img
      src={brokenImg}
      alt="Broken"
      width="35px"
      height="35px"
      style={{ marginBottom: "10px" }}
    />
    <Text
      strong
      style={{
        fontSize: "20px",
        lineHeight: 1,
        textAlign: "center",
        color: "#ffffffa6",
      }}
    >
      Unable to retrieve data
    </Text>
  </Flex>
);
